import { defineComponent } from "../../../common/runtime/defineComponent.svelte";
import type { Props } from "./SnackbarV1.types";

defineComponent<Props>({
  tag: "oc-snackbar-v1",
  props: {
    open: { type: "Boolean" },
    message: {},
    id: { reflect: true },
    autoDismiss: { attribute: "auto-dismiss" },
    forceReplaceExistingInstance: { type: "Boolean", attribute: "force-replace-existing-instance" },
  },
  component: () => import("./SnackbarV1.svelte"),
});
